import { IconButton } from '@mui/material'
import { Dismiss24Regular } from '@/components/Icon'
import ThreadsSearchDialogWorkspaceTabs from './ThreadsSearchDialogWorkspaceTabs'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSearchDialogHeader({ onClose, workspaceScope, onWorkspaceScopeChange }) {
  return (
    <header className={styles.header}>
      <div className={styles.headerStart}>
        <ThreadsSearchDialogWorkspaceTabs value={workspaceScope} onChange={onWorkspaceScopeChange} />
      </div>
      <IconButton type="button" aria-label="Close threads" onClick={onClose} size="small" className={styles.closeButton}>
        <Dismiss24Regular className={styles.closeIcon} aria-hidden />
      </IconButton>
    </header>
  )
}
